module.exports = __webpack_public_path__ + "img/object.eca2d394.svg";